import { useState, useEffect, useCallback, useRef } from "react";

const COOLDOWN_SECONDS = 60;

export function useResendCooldown() {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>(undefined);
  const isOnCooldown = secondsLeft > 0;

  useEffect(() => {
    if (!isOnCooldown) {
      clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(() => {
      setSecondsLeft((s) => s - 1);
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [isOnCooldown]);

  const startCooldown = useCallback(() => {
    setSecondsLeft(COOLDOWN_SECONDS);
  }, []);

  return { secondsLeft, isOnCooldown, startCooldown };
}
